import { BaseFetch } from "../main-model"
export default class EducationModel extends BaseFetch {
    getEducationBy = (data) =>
    this.authFetch({
      url: "education/getEducationBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getEducationById = (data) =>
    this.authFetch({
      url: "education/getEducationById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateEducationById = (data) =>
    this.authFetch({
      url: "education/updateEducationById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertEducation = (data) =>
    this.authFetch({
      url: "education/insertEducation",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteEducationById = (data) =>
    this.authFetch({
      url: "education/deleteEducationById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
